import { Text as RebassText } from "rebass";

// Basic Text
function Text(props) {
  return <RebassText {...props} />;
}

export default Text;
